export const PROFILE_ACTION = "PROFILE_ACTION";
export const DEVICES_ACTION = "DEVICES_ACTION";
export const ADD_DEVICE_TO_REPAIR_ACTION = "ADD_DEVICE_TO_REPAIR_ACTION";
export const ISSUES_ACTION = "ISSUES_ACTION";
export const AVAILABILITY_ACTION = "AVAILABILITY_ACTION";
export const LOGIN_ERROR_ACTION = "LOGIN_ERROR_ACTION";
export const REGISTER_ERROR_ACTION = "REGISTER_ERROR_ACTION";
export const USER_DEVICES_ACTION = "USER_DEVICES_ACTION";
export const USER_ADDRESSES_ACTION = "USER_ADDRESSES_ACTION";
export const ZIP_CODES_ACTION = "ZIP_CODES_ACTION";
export const USER_ZIP_CODE_ACTION = "USER_ZIP_CODE_ACTION";
export const APPOINTMENTS_LIST_ACTION = "APPOINTMENTS_LIST_ACTION";
export const PUSH_NOTIFICATIONS_ACTION = 'PUSH_NOTIFICATIONS_ACTION';
export const ADD_NOTIFICATIONS_ACTION = 'ADD_NOTIFICATIONS_ACTION';
export const CLEAR_NOTIFICATIONS_ACTION = 'CLEAR_NOTIFICATIONS_ACTION';
export const REMOVE_NOTIFICATION_ACTION = 'REMOVE_NOTIFICATION_ACTION';
export const REMOVE_GENERIC_NOTIFICATIONS_ACTION = 'REMOVE_GENERIC_NOTIFICATIONS_ACTION';
export const NOTIFICATION_VIEWED_ACTION = 'NOTIFICATION_VIEWED_ACTION';
export const PUSH_ADDRESS_ACTION = 'PUSH_ADDRESS_ACTION';
export const REMOVE_ADDRESS_ACTION = 'REMOVE_ADDRESS_ACTION';
export const RECEIVE_APPOINTMENT_ADDRESS_ACTION = 'RECEIVE_APPOINTMENT_ADDRESS_ACTION';
export const RECEIVE_APPOINTMENT_HOUR_SLOT_ACTION = 'RECEIVE_APPOINTMENT_HOUR_SLOT_ACTION';
export const RECEIVE_PAYMENT_TOKEN_ACTION = 'RECEIVE_PAYMENT_TOKEN_ACTION';
export const RECEIVE_CARDS_ACTION = 'RECEIVE_CARDS_ACTION';
export const CLEAR_APPOINTMENT_DATA = 'CLEAR_APPOINTMENT_DATA';
export const REMOVE_NOTIFICATION_BY_TYPE_ACTION = 'REMOVE_NOTIFICATION_BY_TYPE_ACTION';
export const CLEAR_STORE_ACTION = 'CLEAR_STORE_ACTION';

export const receive_profile = profile => {
    return ({
        type: PROFILE_ACTION,
        data: profile
    })
};

export const receive_devices = devices => {
    return ({
        type: DEVICES_ACTION,
        data: devices
    })
};
export const add_device_to_repair = device => {
    return ({
        type: ADD_DEVICE_TO_REPAIR_ACTION,
        data: device
    })
};

export const receive_issues = issues => {
    return ({
        type: ISSUES_ACTION,
        data: issues
    })
};

export const receive_availabilitySlots = slots => {
    return ({
        type: AVAILABILITY_ACTION,
        data: slots
    })
};

export const receive_register_error = error => {
    return ({
        type: REGISTER_ERROR_ACTION,
        data: error
    })
};

export const receive_login_error = error => {
    return ({
        type: LOGIN_ERROR_ACTION,
        data: error
    })
};

export const receive_user_devices = userDevices => {
    return ({
        type: USER_DEVICES_ACTION,
        data: userDevices
    })
};

export const receive_user_addresses = addresses => {
    return ({
        type: USER_ADDRESSES_ACTION,
        data: addresses
    })
};

export const receive_zip_codes = zip_codes => {
    return ({
        type: ZIP_CODES_ACTION,
        data: zip_codes
    })
};

export const receive_user_zip_code = zipCode => {
    return ({
        type: USER_ZIP_CODE_ACTION,
        data: zipCode
    })
};

export const receive_appointmentsList = appointments => {
    return ({
        type: APPOINTMENTS_LIST_ACTION,
        data: appointments
    })
};

export const push_notification = notification => {
    return ({
        type: PUSH_NOTIFICATIONS_ACTION,
        data: notification
    })
};

export const add_notification = notification => ({
    type: ADD_NOTIFICATIONS_ACTION,
    data: notification
});

export const clear_notifications = _ => {
    return ({
        type: CLEAR_NOTIFICATIONS_ACTION,
    })
};

export const remove_notification = notification_id => {
    return ({
        type: REMOVE_NOTIFICATION_ACTION,
        data: notification_id
    })
};

export const notification_viewed = () => {
    return ({
        type: NOTIFICATION_VIEWED_ACTION,
    })
};

export const remove_generic_notifications = () => {
    return ({
        type: REMOVE_GENERIC_NOTIFICATIONS_ACTION,
    })
};

export const push_address = address => {
    return ({
        type: PUSH_ADDRESS_ACTION,
        data: address
    })
};
export const remove_address = address_id => {
    return ({
        type: REMOVE_ADDRESS_ACTION,
        data: address_id
    })
};
export const receive_appointment_address = id => {
    return ({
        type: RECEIVE_APPOINTMENT_ADDRESS_ACTION,
        data: id
    })
};
export const receive_appointment_hour_slot = data => {
    return ({
        type: RECEIVE_APPOINTMENT_HOUR_SLOT_ACTION,
        data: data
    })
};
export const receive_payment_token = card => {
    return ({
        type: RECEIVE_PAYMENT_TOKEN_ACTION,
        data: card
    })
};
export const receive_cards = cards => {
    return ({
        type: RECEIVE_CARDS_ACTION,
        data: cards
    })
};

export const clear_appointment_data = data => {
    return ({
        type: CLEAR_APPOINTMENT_DATA,
        data: data
    })
};

export const remove_notificationByType = data => {
    return ({
        type: REMOVE_NOTIFICATION_BY_TYPE_ACTION,
        data: data
    })
};

export const clear_store = () => {
    return ({
        type: CLEAR_STORE_ACTION,
    })
}
